import { render } from "./OpenbonusView.vue?vue&type=template&id=50cd0c89&scoped=true"
import script from "./OpenbonusView.vue?vue&type=script&lang=js"
export * from "./OpenbonusView.vue?vue&type=script&lang=js"

import "./OpenbonusView.vue?vue&type=style&index=0&id=50cd0c89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cd0c89"]])

export default __exports__